import type { IMatchingSearchState } from "./matching-search.types";

import { ActionTree } from "vuex";

import { RootState } from "@/services/store/root-state";
import { getBaseName } from "@/services/store/utils/get-base-name";
import { EMatchingSearchActions } from "./matching-search.types";
import { matchingSearchProvider } from "@/services/data/matching-search/matching-search.provider";
import { EMatchingSearchMutations } from "./matching-search.types";

const generateFilters = (filters: any, page: number, per_page: number) => {
  // let filter_by = "type:!=supporter";
  let filter_by = "";

  if (filters.sectors?.length > 0) {
    filter_by = `sectors:[${filters.sectors.join(",")}]`;
  }

  if (filters.countries?.length > 0) {
    if (filter_by) {
      filter_by += ` || `;
    }
    filter_by += `countries:[${filters.countries.join(",")}]`;
  }

  if (filters.vil?.length > 0) {
    if (filter_by) {
      filter_by += ` || `;
    }
    filter_by += `vil:[${filters.vil.join("..")}]`;
  }

  if (filters.founding_date?.length > 0) {
    if (filter_by) {
      filter_by += ` && `;
    }

    const sorted = filters.founding_date.sort((a: number, b: number) => a - b);
    if (sorted.length === 1) {
      filter_by += `founding_date:[${sorted[0]}]`;
    } else {
      filter_by += `founding_date:[${sorted[0] + ".." + sorted[sorted.length - 1]}]`;
    }
  }

  const sort_by = `founding_date:${filters.sort === "desc" ? "desc" : "asc"}`;

  return {
    filter: filter_by,
    query: filters.query,
    sort_by,
    page: page,
    per_page: per_page,
  };
};

export const actions: ActionTree<IMatchingSearchState, RootState> = {
  async [getBaseName(EMatchingSearchActions.LOAD_FACETS)]({ commit, state }) {
    try {
      commit(EMatchingSearchMutations.SET_LOADING, true);
      commit(EMatchingSearchMutations.SET_FACETS, []);
      commit(EMatchingSearchMutations.SET_ERROR, null);
      const results = await matchingSearchProvider.facets(
        generateFilters(state?.filters, 1, 30),
      );

      const facets: any = {};
      for (const facet of results) {
        facets[facet.field_name] = {
          facet: facet.field_name,
          options: facet.counts.map((count: any) => ({
            value: count.value,
            label: count.highlighted,
            count: count.count,
          })),
        };
      }

      commit(EMatchingSearchMutations.SET_FACETS, facets);
      commit(EMatchingSearchMutations.SET_LOADING, false);
    } catch (error: any) {
      commit(EMatchingSearchMutations.SET_ERROR, error.message);
      commit(EMatchingSearchMutations.SET_LOADING, false);
    }
  },

  async [getBaseName(EMatchingSearchActions.SEARCH)](
    { state, commit, dispatch },
    action: string,
  ) {
    try {
      commit(EMatchingSearchMutations.SET_LOADING, true);
      commit(EMatchingSearchMutations.SET_ERROR, null);
      const results = await matchingSearchProvider.search(
        generateFilters(
          state?.filters,
          action === "scroll" ? state.page + 1 : 1,
          state.per_page,
        ),
      );

      commit(EMatchingSearchMutations.SET_RESULTS, {
        documents: results.hits.map((hit: any) => hit.document),
        found: results.found,
        page: results.page,
        per_page: results.per_page,
        action: action,
      });
      commit(EMatchingSearchMutations.SET_LOADING, false);

      return results.page * results.request_params.per_page < results.found;
    } catch (error: any) {
      commit(EMatchingSearchMutations.SET_ERROR, error.message);
      commit(EMatchingSearchMutations.SET_LOADING, false);
      console.log(error);
      return false;
    }
  },

  async [getBaseName(EMatchingSearchActions.SET_FILTERS)](
    { commit },
    data: any,
  ) {
    commit(EMatchingSearchMutations.SET_FILTERS, data);
  },
};
